<template>
  <b-container fluid class="mb-2 p-0">
    <b-tabs class="drawing-request-tabs" nav-wrapper-class="px-3 pt-2 pb-2" content-class="px-3" small>
      <b-tab title="Miembros" active class="fs-16">
        <DrawingRequestShowMembers
          :drawing-request="drawingRequest"
          :permissions="permissions"
          @updated="$emit('updated', $event)"
        />
      </b-tab>

      <b-tab :title="`Submitals (${itemsCount})`">
        <DrawingRequestShowItems
          :drawing-request="drawingRequest"
          :permissions="permissions"
          @item-added="$emit('item-added', $event)"
          @item-removed="$emit('item-removed', $event)"
        />
      </b-tab>

      <b-tab :title="`Adjuntos (${attachmentsCount})`">
        <DrawingRequestShowAttachments
          :drawing-request="drawingRequest"
          :loading-attachment-id="loadingAttachmentId"
          @open-attachment="$emit('open-attachment', $event)"
        />
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import DrawingRequestShowAttachments from './DrawingRequestShowAttachments'
import DrawingRequestShowMembers from './DrawingRequestShowMembers'
import DrawingRequestShowItems from './DrawingRequestShowItems'

export default {
  name: 'DrawingRequestShowTabs',
  components: { DrawingRequestShowAttachments, DrawingRequestShowMembers, DrawingRequestShowItems },
  props: {
    drawingRequest: { type: Object, required: true },
    permissions: { type: Object, default: () => ({}) },
    loadingAttachmentId: { type: Number, default: null }
  },
  computed: {
    itemsCount () {
      return (this.drawingRequest.drawing_request_items || []).length
    },
    attachmentsCount () {
      return (this.drawingRequest.comments || []).filter(c => c.document || c.photo).length
    }
  }
}
</script>

<style scoped>
.drawing-request-tabs ::v-deep .nav-link {
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  color: #5f6873;
  font-size: 15px;
}
.drawing-request-tabs ::v-deep .nav-link.active {
  background: transparent;
  border-bottom-color: #163D7D;
  color: #163D7D;
  font-weight: 700;
}
</style>
